import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import { Button } from '../components/ui/button';
import './LegalPage.css';

export const LegalPage = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-page-header">
        <Button 
          variant="outline" 
          onClick={() => navigate('/')}
          className="back-button"
        >
          <ArrowLeft size={20} />
          Retour
        </Button>
      </div>

      <div className="legal-page-container">
        <div className="legal-hero">
          <FileText size={48} />
          <h1>Mentions Légales</h1>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Éditeur du Site</h2>
            <div className="info-box">
              <p><strong>Raison sociale :</strong> LUNETTERIE DU RUSSEY</p>
              <p><strong>Forme juridique :</strong> Société à Responsabilité Limitée (SARL)</p>
              <p><strong>SIRET :</strong> 80336325800028</p>
              <p><strong>Siège social :</strong> 3 RUE DES RONDEYS, 25210 LE RUSSEY</p>
              <p><strong>Téléphone :</strong> 03 81 67 90 20</p>
              <p><strong>Email :</strong> lunetteriedurussey@gmail.com</p>
              <p><strong>Gérante :</strong> Elise ARNOUX</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>2. Hébergement</h2>
            <div className="info-box">
              <p><strong>Hébergeur :</strong> OVH</p>
              <p><strong>Siège social :</strong> 2 rue Kellermann, 59100 Roubaix, France</p>
              <p><strong>Téléphone :</strong> 1007 (depuis la France)</p>
              <p><strong>Site web :</strong> <a href="https://www.ovhcloud.com" target="_blank" rel="noopener noreferrer">www.ovhcloud.com</a></p>
            </div>
          </section>

          <section className="legal-section">
            <h2>3. Propriété Intellectuelle</h2>
            <p>
              L'ensemble du contenu présent sur ce site (textes, images, graphismes, logo, icônes, etc.) est la propriété exclusive 
              de la LUNETTERIE DU RUSSEY, à l'exception des marques citées qui appartiennent à leurs propriétaires respectifs.
            </p>
            <p>
              Toute reproduction, distribution, modification, adaptation, retransmission ou publication de ces différents éléments 
              est strictement interdite sans l'accord express par écrit de la LUNETTERIE DU RUSSEY.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Données Personnelles</h2>
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, 
              vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données vous concernant.
            </p>
            <p>
              Pour plus d'informations, consultez notre <a href="/politique-de-confidentialite">Politique de Confidentialité</a>.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Cookies</h2>
            <p>
              Ce site n'utilise <strong>aucun cookie de suivi, de marketing ou d'analyse statistique</strong> (pas de Google Analytics, 
              Facebook Pixel, ou autres traceurs tiers).
            </p>
            <p>
              Seuls des cookies strictement nécessaires au fonctionnement technique du site peuvent être utilisés 
              (cookies de session). Ces cookies ne nécessitent pas votre consentement.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Responsabilité</h2>
            <p>
              La LUNETTERIE DU RUSSEY s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. 
              Toutefois, elle ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition.
            </p>
            <p>
              La LUNETTERIE DU RUSSEY ne pourra être tenue responsable des dommages directs ou indirects pouvant résulter de 
              l'accès au site ou de l'utilisation des informations qui y sont contenues.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Liens Hypertextes</h2>
            <p>
              Le site peut contenir des liens vers d'autres sites internet. La LUNETTERIE DU RUSSEY n'exerce aucun contrôle sur 
              ces sites et décline toute responsabilité quant à leur contenu.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Droit Applicable</h2>
            <p>
              Les présentes mentions légales sont soumises au droit français. En cas de litige, et après tentative de recherche 
              d'une solution amiable, les tribunaux français seront seuls compétents.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Contact</h2>
            <p>Pour toute question concernant ces mentions légales, contactez-nous :</p>
            <div className="info-box">
              <p><strong>Email :</strong> lunetteriedurussey@gmail.com</p>
              <p><strong>Téléphone :</strong> 03 81 67 90 20</p>
              <p><strong>Adresse :</strong> 3 RUE DES RONDEYS, 25210 LE RUSSEY</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};